import { getSegmentStates } from 'admin/views/site-designer/data';
import {
   MENU_SEGMENT_KEY,
} from 'admin/views/site-designer/data';

const leftSideStates = getSegmentStates();

const initialState = {
   pagesList: [],
   selectedPagesState: {},
   fetchPublishDraftContent: false,
   fetchSaveAsDraft: false,
   leftSideFetching: true,
   rightSideFetching: true,
   currentPage: {},
   reservCurrentPage: {},
   pageSections: {},
   reservPageSections: {},
   globalSettings: {},
   reservGlobalSettings: {},
   currentSegment: leftSideStates[MENU_SEGMENT_KEY],
   currentSectionUuid: '', // section uuid or global settings type
   contentResources: {
      cast_members: [],
      collections: [],
      tags: [],
      categories: [],
      video_collections: [],
      photoset_collections: [],
   },
   savedData: {},
   prepearComponentForRender: {
      left: false,
      right: false,
   },
   rightSide: null,
   previousState: {},
};

export default initialState;
